"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var header_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/request_detail/header"));
var body_1 = __importDefault(require("~/components/users/estimates/requests/unread_request/request_detail/body"));
var RequestDetail = function (props) {
    var wrapperClassName = (0, classnames_1.default)("unreadRequestWindow-RequestDetail_Wrapper", {
        "unreadRequestWindow-RequestDetail_Wrapper-hidden": !props.isRequestDetailVisible
    });
    return (react_1.default.createElement("div", { className: wrapperClassName }, props.request &&
        react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(header_1.default, { store: props.request.store, onClickLeftAngle: props.onClickLeftAngle }),
            react_1.default.createElement(body_1.default, { request: props.request, isMessageSubmitting: props.isMessageSubmitting, onClickSubmitButton: props.onClickSubmitButton }))));
};
exports.default = RequestDetail;
